var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFavorite01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 611 611",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-1,.cls-2{stroke-width:0px;}.cls-3{clip-path:url(#clippath);}.cls-2{fill:#657479;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 611,
    height: 611
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_-_inatcve"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18347"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32431",
    className: "cls-2",
    d: "M305.5,30.92c54.7-.1,108.17,16.23,153.48,46.86,44.17,29.82,78.75,71.81,99.53,120.89,36.19,85.48,26.67,183.46-25.3,260.38-29.8,44.14-71.76,78.69-120.79,99.47-85.48,36.19-183.46,26.67-260.38-25.3-44.16-29.77-78.74-71.69-99.56-120.7-36.19-85.48-26.67-183.46,25.3-260.38,29.78-44.2,71.74-78.82,120.79-99.65,33.83-14.31,70.19-21.65,106.92-21.57M305.5.09C136.78.09,0,136.87,0,305.59s136.78,305.5,305.5,305.5,305.5-136.78,305.5-305.5S474.22.09,305.5.09M292.06,136.16l-41.82,96.11-104.27,10.08c-8.05.76-13.95,7.9-13.19,15.94.35,3.7,2.1,7.14,4.89,9.6l78.42,69.47-22.64,102.28c-1.76,7.89,3.2,15.71,11.09,17.47,3.63.81,7.43.21,10.63-1.68l90.34-53.19,90.31,53.03c6.96,4.11,15.93,1.8,20.04-5.16,1.89-3.2,2.49-7,1.68-10.63l-22.64-102.28,78.42-69.47c6.06-5.35,6.64-14.6,1.29-20.65-2.46-2.79-5.89-4.54-9.6-4.89l-104.24-9.93-41.82-96.11c-3.21-7.42-11.83-10.82-19.25-7.61-3.41,1.48-6.13,4.2-7.61,7.61"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFavorite01);
export default __webpack_public_path__ + "static/media/icon-favorite-01.dbee6df64fbf0229819a9771f3267fad.svg";
export { ForwardRef as ReactComponent };